import {createFromIconfontCN} from '@ant-design/icons';

/**
 * 图标组件(生产环境需使用本地资源)
 */
const Icon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_4927637_a3c6k1xkkit.js', // 在 iconfont.cn 上生成
});

/**
 * 图标数据
 */
const shuJuKu = "icon-shujuku";//文档
const Light = "icon-light";
const Dark = "icon-dark";
const Login = "icon-login";
const Big = "icon-big";
const CaiDan = "icon-caidan"
const ShuJu = "icon-shuju"
const SheZi = "icon-shezhi"
const DB = "icon-db"
const Log = "icon-log"
const Out = "icon-out"
const Config = "icon-config"
const ShuiDian = "icon-shuidian"
const Video = "icon-shipin"
const DaoZha = "icon-daozha"
const KongTiao = "icon-kongtiao"
const XiuGai = "icon-xiugai"
const Juese = "icon-yonghu"
const Baobiao = "icon-tongji"
const ZhiBao = "icon-zhibo"
const Marketing = "icon-yingxiao"
const Material = "icon-sucai"
const Point = "icon-jifen"



export {
    Icon,
    Point,
    shuJuKu,
    Marketing,
    Material,
    Light,
    Dark,
    Login,
    Big,
    CaiDan,
    ShuJu,
    SheZi,
    DB,
    Log,
    Out,
    Config,
    ShuiDian,
    Video,
    DaoZha,
    KongTiao,
    XiuGai,
    Juese,
    Baobiao,
    ZhiBao
}